import React, { Fragment } from 'react';

import { formatFigure } from 'Helpers/formatService';

export default function SupplierContractReductionTable({ data = [] }) {
    if (!data.length) {
        return null;
    }

    return (
        <div>
            <h4 className="table__header tw-mb-6">{$t('Reductions to Contract Value')}</h4>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th>{$t('Date')}</th>
                            <th>{$t('User')}</th>
                            <th>{$t('Item')}</th>
                            <th>{$t('Venue')}</th>
                            <th>{$t('Original Quantity')}</th>
                            <th>{$t('Revised Quantity')}</th>
                            <th>{$t('Variance')}</th>
                            <th>{$t('Price')}</th>
                            <th>{$t('Total Variation')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((contractReductionLog) => (
                            <Fragment key={contractReductionLog.id}>
                                <tr>
                                    <td>{contractReductionLog.date}</td>
                                    <td>{contractReductionLog.user}</td>
                                    <td>{contractReductionLog.item}</td>
                                    <td>{contractReductionLog.venue ?? 'N/A'}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(contractReductionLog.original_quantity)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(contractReductionLog.revised_quantity)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(contractReductionLog.variance)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(contractReductionLog.price)}</td>
                                    <td className="inbud-numeric-cell">{formatFigure(contractReductionLog.total_variation)}</td>
                                </tr>
                            </Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
